import { E as i, B as a } from "./config-9944f489.js";
import { c as n } from "./color.service-333613ec.js";
async function r(e) {
  const o = await (await fetch(i)).text(), s = new DOMParser().parseFromString(o, "image/svg+xml").documentElement, t = e.importNode(s, !0);
  t.id = "jolt-icons", t.style.width = 0, t.style.height = 0, t.style.position = "absolute", t.style.overflow = "hidden", e.body.appendChild(t);
}
function l(e) {
  const { document: o } = e;
  o.getElementById("jolt-icons") || (typeof e.cordova == "object" ? o.addEventListener("deviceready", () => r(o)) : r(o));
}
function m(e = a) {
  n.setColorStyles({ value: e }, n.getBrandColorModel());
}
export {
  m as brandColorLoader,
  l as iconsLoader
};
